// src/postsSlice.js
import api from '../../services/api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
export const getStudentsList = createAsyncThunk(
  'getstudents/fetchAll',
  async (searchParameters) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/students/all',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...searchParameters,
        },
      });

      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const getStudentById = createAsyncThunk(
  'getstudents/ById',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/${id}`,
        method: 'GET',
      });

      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const studentIdCheck = createAsyncThunk(
  'studentIdCheckfetch',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/idCheck/${id}`,
        method: 'GET',
      });

      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const deleteStudentById = createAsyncThunk(
  'students/delete',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/${id}`,
        method: 'DELETE',
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const postStudentData = createAsyncThunk(
  'students/post',
  async (studentData) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/students/',
        method: 'POST',
        data: studentData,
      });

      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const updateStudentData = createAsyncThunk(
  'students/update',
  async (studentData) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/students/',
        method: 'PUT',
        data: studentData,
      });

      return response?.status;
    } catch (error) {
      console.log(error);
    }
  },
);

export const uploadImage = createAsyncThunk(
  'students/uploadImage',
  async (photo) => {
    try {
      const formData = new FormData();
      formData.append('img', photo);
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/uid',
        method: 'POST',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);

export const uploadXl = createAsyncThunk('students/uploadXl', async (file) => {
  try {
    const response = await api({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      url: `/students/file/${file[1]}`,
      method: 'POST',
      data: file[0],
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    //console.log(response);
    return response?.data;
  } catch (error) {
    console.log(error);
  }
});

export const getImage = createAsyncThunk(
  'students/getImage',
  async (identifier) => {
    // console.log(identifier);
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/getimg/${identifier}`,
        method: 'GET',
      });
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const getStudentCurrentMarksAndPayments = createAsyncThunk(
  'getstudents/ById',
  async (id) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/students/currentinfo?studentId=${id}`,
        method: 'GET',
      });

      return response?.data;
    } catch (error) {
      console.log(error);
    }
  },
);
export const getTCDetails = createAsyncThunk(
  'getTCDetails/fetchAll',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `/tc/${id}`,
        method: 'GET',
      });

      return { data: response?.data, status: response.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response.status,
      });
    }
  },
);
export const postTCDetails = createAsyncThunk(
  'postTCDetails',
  async (details, { rejectWithValue }) => {
    try {
      const response = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: '/tc/',
        method: 'PUT',
        data: details,
      });
      return { data: response?.data, status: response?.status };
    } catch (error) {
      console.log(error);
      return rejectWithValue({
        data: error?.response?.data,
        status: error?.response.status,
      });
    }
  },
);
const studentSlice = createSlice({
  name: 'students',
  initialState: {
    studentsData: {},
    status: '',
    error: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStudentsList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getStudentsList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.studentsData = action.payload;
      })
      .addCase(getStudentsList.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.error.message;
      });
  },
});

export default studentSlice.reducer;
